import React from 'react';
import KPI from './KPI';

const DashboardTab = () => (
  <div className="space-y-1">
    <h2 className="text-2xl font-semibold text-gray-800 px-4 pt-2">
      Reliant Calls Deep Analytics
    </h2>

    <div className="bg-white rounded shadow overflow-hidden">
      <iframe
        title="QuickSight Dashboard"
        className="w-full h-[600px]"
        src="https://us-east-1.quicksight.aws.amazon.com/sn/embed/share/accounts/991028191336/dashboards/9061eb83-f41d-4ada-bb4f-5c6c07e89e0e?directory_alias=yaqeentechdemo"
        frameBorder="0"
      ></iframe>
    </div>
  </div>
);

export default DashboardTab;

